<template>
  <el-dialog title="查看自动问答" :visible="isShowType" @close='closeDialog' width='480px' :append-to-body="true"
    :destroy-on-close="true" :close-on-click-modal='false'>
    <el-form class="form-wrap" :model="info" ref="question" label-width="100px">
      <el-form-item label="问题：" prop="question">
        {{ info.question }}
      </el-form-item>
      <el-form-item label="关键词：" prop="keyWord">
        {{ info.keyWord }}
      </el-form-item>
      <el-form-item label="回答：" prop="answer">
        {{ info.answer }}
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
export default {
  typeName: 'CustomerManageDetail',
  props: {
    id: {
      type: String,
      default: ''
    },
    isShowType: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      info: {
        question: '',
        keyWord: '',
        answer: ''
      }
    }
  },
  created() {
    this.getSetting()
  },
  watch: {
  },
  computed: {
  },
  methods: {
    getSetting() {
      this.$axios.get(this.$apis.tourist.selectKfAnswerById, {
        id: this.id
      }).then(res => {
        this.info = res || {}
      })
    },
    closeDialog() {
      this.$emit('update:isShowType', false)
      this.$emit('close')
    }
  }
}
</script>
<style scoped lang="scss"></style>
